import { Image } from "uikit-react";
import classnames from "classnames";
import moment from "moment";
import Tags from "../../common/Tags";

const WorkOrderRow = ({
  workOrder,
  idx,
  rental,
  statusLabel,
  getAssignees,
  diffDate,
  handleSelectedTags,
  handleEditWorkOrder,
  handleClickDelete,
  slug,
}) => {
  return (
    <tr key={`workorder_${idx}`}>
      <td>
        <div>{workOrder.id}</div>
      </td>
      <td>
        <div>
          <div className="hms-wo-summary">
            {workOrder.summary}
          </div>
          {workOrder.guest_reservation?.name && (
            <div className="secondary">
              Guest: {workOrder.guest_reservation.name}
            </div>
          )}
          {rental?.pms_id && (
            <div className="secondary">
              {rental.pms_id} {rental.name ? `· ${rental.name}` : ""}
            </div>
          )}
          {rental?.address && (
            <div className="secondary">
              {rental.address}
            </div>
          )}
        </div>
      </td>

      <td>
        <div className="hms-wo-status-priority">
          {statusLabel && (
            <div className="hms-booking-tag">
              {statusLabel.replace("-", " ")}
            </div>
          )}
          {workOrder.priority && (
            <div className={classnames("hms-chip", `priority-${workOrder.priority}`)}>
              {workOrder.priority}
            </div>
          )}
        </div>
      </td>
      <td className="capitalize">
        {workOrder.category}
      </td>
      <td>
        <div>{getAssignees(workOrder) || <span className="secondary">Unassigned</span>}</div>
      </td>

      <td>
        <div>
          {workOrder.checklist_item_count != null && workOrder.checklist_item_count > 0 
            ? `${workOrder.checklist_item_count} item${workOrder.checklist_item_count !== 1 ? 's' : ''}`
            : ""}
        </div>
      </td>
      <td>
        <div>
          <div>
            {workOrder.total_cost != null ? `Tot: $${(Number(workOrder.total_cost) / 100).toFixed(2)}` : ""}
          </div>
          {workOrder.material_cost && (
            <div className="secondary">
              {`Mat: $${(Number(workOrder.material_cost) / 100).toFixed(2)}`}
            </div>
          )}
          {workOrder.labor_cost && (
            <div className="secondary">
              {`Lab: $${(Number(workOrder.labor_cost) / 100).toFixed(2)}`}
            </div>
          )}
        </div>
      </td>

      {/* Tags */}
      <td className="hms-add-tag">
        <Tags
          value={workOrder?.tags || []}
          onChange={(event) => handleSelectedTags(event, workOrder)}
        />
      </td>

      {/* Last Updated */}
      <td>
        <div>
          <div>
            {moment
              .utc(workOrder.updated_at)
              .local()
              .format("MM/DD/YYYY hh:mm a")}
          </div>
          <div className="secondary">{diffDate(workOrder.updated_at)}</div>
        </div>
      </td>

      {/* Actions */}
      <td className="hms-action-btn">
        <div className="uk-flex uk-flex-top">
          <div className="uk-inline">
            <button
              className="uk-button"
              uk-toggle="target: #work-order-add"
              onClick={() => handleEditWorkOrder(workOrder.id)}
              uk-tooltip="Edit"
            >
              <Image src="/images/edit.svg" />
            </button>
          </div>
          <div className="uk-inline">
            {slug ? (
              <a
                href={`/work-orders/${slug}/${workOrder.id}`}
                target="_blank"
                rel="noreferrer"
              >
                <button className="uk-button" uk-tooltip="Comment">
                  <Image src="/images/workorder-comment.svg" />
                </button>
              </a>
            ) : (
              <a href={`/work-orders/${workOrder.id}`} target="_blank" rel="noreferrer">
                <button className="uk-button" uk-tooltip="Comment">
                  <Image src="/images/workorder-comment.svg" />
                </button>
              </a>
            )}
          </div>
          <div className="uk-inline">
            <button
              className="uk-button"
              uk-toggle="target: #work-order-delete"
              onClick={() => handleClickDelete(workOrder)}
              uk-tooltip="Delete"
            >
              <Image src="/images/delete.svg" />
            </button>
          </div>
        </div>
      </td>
    </tr>
  );
};

export default WorkOrderRow;
